import {
  gasOrderGetData
} from '@/api/api'

import {
  dealGasOrder
} from '@/cllib/sys_lib'

const state = {
  piGasOrder: [],
  piChooseGasOrder: null
}

const getters = {
  piGasOrder: state => state.piGasOrder,
  piChooseGasOrder: state => state.piChooseGasOrder
}

const actions = {
  loadPiGasOrder ({ dispatch, getters }) {
    let parm = {
      noPage: 1,
      sendTime: getters.piDateStr,
      isSend: 1
    }
    return gasOrderGetData(parm).then((data) => {
      dispatch('setPiGasOrder', dealGasOrder(data))
    })
  },
  setPiGasOrder ({ commit }, data) {
    commit('setPiGasOrder', data)
  },
  setPiChooseGasOrder ({ commit, dispatch }, data) {
    commit('setPiChooseGasOrder', data)
    dispatch('setPiGasTankId', {gasTankId: data ? (data.gasTankId || null) : null, piChartType: 'pi'})
  },
  updateOverRate ({ commit }, data) {
    commit('updateOverRate', data)
  }
}

const mutations = {
  setPiGasOrder (state, data) {
    state.piGasOrder = data
  },
  setPiChooseGasOrder (state, data) {
    state.piChooseGasOrder = data
  },
  updateOverRate (state, {id, volume}) {
    state.piGasOrder.forEach((item) => {
      if (item.id === id) {
        item.voerRate = parseInt((volume || 0) / item.volume * 100) + '%'
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pi/pi_gas_order.js